import { XCircle } from "lucide-react";
import { Button } from "../../../components/ui/button";
import { useNavigate } from "react-router-dom";

const RegisterDenied = () => {
  const navigate = useNavigate();

  const handleGoToLogin = () => {
    navigate("/");
  };

  return (
    <div className="flex flex-col items-center justify-center gap-4 sm:gap-6 text-black03 px-4">
      <div className="flex flex-col items-center gap-3 sm:gap-4 text-center max-w-md">
        <XCircle className="h-12 w-12 sm:h-16 sm:w-16 text-red-500" />
        <h2 className="text-lg sm:text-2xl font-semibold text-red-600">Cadastro negado</h2>
        <p className="text-xs sm:text-sm leading-relaxed">
          Desculpe, seu cadastro foi negado. Por favor, entre em contato com o
          suporte.
        </p>

        <Button
          type="button"
          onClick={handleGoToLogin}
          className="mt-2 sm:mt-4 h-11 sm:h-12 bg-primary px-6 sm:px-8 text-white hover:bg-primary/90 text-sm sm:text-base w-full sm:w-auto"
        >
          Sair
        </Button>
      </div>
    </div>
  );
};

export default RegisterDenied;
